import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";
import Firebase from "./Firebase";

let functionsInstance = null;
let emulatorConnected = false;

export function shouldUseFunctionsEmulator() {
	return (
		process.env.NODE_ENV === "development" &&
		process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === "true"
	);
}

export function getFunctionsEmulatorHost() {
	return process.env.REACT_APP_FUNCTIONS_EMULATOR_HOST || "localhost";
}

export function getFunctionsEmulatorPort() {
	return Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || 5001);
}

export function getFunctionsInstance() {
	if (!functionsInstance) {
		functionsInstance = getFunctions(Firebase, "us-central1");
	}

	if (
		!emulatorConnected &&
		typeof window !== "undefined" &&
		shouldUseFunctionsEmulator()
	) {
		connectFunctionsEmulator(
			functionsInstance,
			getFunctionsEmulatorHost(),
			getFunctionsEmulatorPort()
		);
		emulatorConnected = true;
	}

	return functionsInstance;
}

export function getCallable(functionName) {
	return httpsCallable(getFunctionsInstance(), functionName);
}
